export default {
  // logged out
  activate: null,
  login: null,
  register: null,
  'reset-password': null,
  // logged in
  'address-book': null,
  'edit-profile': null,
  order: null,
  orders: null,
};
